import {useTranslation} from "../i18n";
import {DataState} from "./DataState";

export const AdminTable = ({columns, rows, rowKey = "id", loading, emptyText}) => {
    const {t} = useTranslation();

    if (loading) {
        return (
            <div className="admin-table-skeleton" aria-label={t("common.table.loading")}>
                {Array.from({length: 6}).map((_, index) => (
                    <span key={index} />
                ))}
            </div>
        );
    }

    if (!rows?.length) {
        return (
            <DataState
                title={emptyText ?? t("common.table.empty")}
                copy={t("common.state.emptyHint")}
            />
        );
    }

    return (
        <div className="admin-table-wrap">
            <table className="admin-table">
                <thead>
                    <tr>
                        {columns.map((column) => (
                            <th key={column.key}>{column.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <tr key={row[rowKey] ?? `${rowKey}-${index}`}>
                            {columns.map((column) => (
                                <td key={column.key}>{column.render ? column.render(row, index) : row[column.key] ?? "—"}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
